import { calculateTimeDifference } from './calculatePlannedHours'
import { PlannedHours } from '../redux/reducers/scheduleDateSlice'

export const getAdjacentDates = (selectedDates: string[], hours: PlannedHours): string[][] => {
  const adjacentDates: string[][] = []
  selectedDates.forEach((date, index) => {
    if (index === 0) {
      adjacentDates.push([date])
    } else {
      const previousDate = selectedDates[index - 1]
      const previousDateIndex = Object.keys(hours).indexOf(previousDate)
      const currentDateIndex = Object.keys(hours).indexOf(date)
      if (previousDateIndex + 1 === currentDateIndex) {
        adjacentDates[adjacentDates.length - 1].push(date)
      } else {
        adjacentDates.push([date])
      }
    }
  })
  return adjacentDates
}

export const calculateTotalHours = (hours: PlannedHours) => {
  let totalHours = 0
  let totalMinutes = 0
  Object.keys(hours).forEach(date => {
    hours[date].forEach(interval => {
      const { hoursDifference, minutesDifference } = calculateTimeDifference(interval.from, interval.to)
      totalHours += hoursDifference
      totalMinutes += minutesDifference
    })
  })
  totalHours += totalMinutes / 60
  totalHours = Math.round(totalHours * 10) / 10
  return totalHours
}
